import { Component, Field } from '@contember/interface'

export const CaseStudyPreview = Component(() => (
	<div>
		<Field field="title" />
	</div>
))
